import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: function () {
      return import( '../views/Home.vue')
    }
  },
   {
    path: '/contact',
    name: 'contact',
    component: function () {
      return import( '../views/Contact.vue')
    }
  },
  {
    path: '/art-design',
    name: 'ArtDesign',
    component: function () {
      return import( '../views/ArtDesign.vue')
    }
  },
  {
    path: '/Industrial',
    name: 'Industrial',
    component: function () {
      return import( '../views/Industrial.vue')
    }
  },
  {
    path: '/Website',
    name: 'Website',
    component: function () {
      return import( '../views/Website.vue')
    }
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 如果瀏覽器有儲存上次位置 (例如點擊後退/前進)，則滾回該位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否則，將頁面滾動到最頂部 (x=0, y=0)
      return { x: 0, y: 0 }
    }
  }
})

export default router
